import { useState } from 'react';

import {
    PlusCircledIcon,
    UpdateIcon
} from '@radix-ui/react-icons';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '../ui/form';
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

import { useForm } from 'react-hook-form';
import api from '../../lib/api';

function CreateNewFarmDialog({ fetchfarms }) {

    const [isDialogOpen, setIsDialogOpen] = useState(false); // Manage dialog open state

    const form = useForm();

    const [preferredName, setPreferredName] = useState('');
    const [breederEmail, setBreederEmail] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    // Submit
    const sendCreationRequest = async (e) => {
        if (isLoading) return; // If loading, return

        e.preventDefault();

        setIsLoading(true); // Set loading to true

        // Send request to create new farm
        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/farms/create`, {
                name: preferredName,
                breederEmail,
            });
            fetchfarms();

            toast({
                title: 'Gård skapad.',
                description: `Gården ${preferredName} har skapats och lagts till i systemet.`,
            });
            setIsDialogOpen(false); // Close dialog on success
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
                <Button className='xl:col-span-2'>
                    <PlusCircledIcon className='mr-3' />
                    Skapa ny gård
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader className='text-left'>
                    <DialogTitle>Skapa ny gård</DialogTitle>
                    <DialogDescription>Ange information för att skapa en ny gård.</DialogDescription>
                </DialogHeader>
                <Form {...form} >
                    <form onSubmit={sendCreationRequest} className="flex flex-col gap-6">
                        <FormField
                            control={form.control}
                            name="farmName"
                            render={({ field }) => (
                                <FormItem className='space-y-0 grid gap-2'>
                                    <FormLabel>Gårdnamn</FormLabel>
                                    <FormControl>
                                        <Input placeholder='Stora gården' onChange={(e) => setPreferredName(e.target.value)} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="breederEmail"
                            render={({ field }) => (
                                <FormItem className='space-y-0 grid gap-2'>
                                    <FormLabel>Uppfödarens e-postadress</FormLabel>
                                    <FormControl>
                                        <Input placeholder='hej@cmdigital.se' type='email' onChange={(e) => setBreederEmail(e.target.value)} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <div className='grid grid-cols-2 gap-3'>
                            <DialogClose asChild>
                                <Button type='button' variant='secondary'>Avbryt</Button>
                            </DialogClose>
                            <Button type="submit"  disabled={isLoading}>
                                {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Skapa gård</>}
                            </Button>
                        </div>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default CreateNewFarmDialog;
